import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import './UserPoll.scss';

import PollOption from '../../Common/PollOption/PollOption';
import VenetianBlindsText from '../../Common/VenetianBlindsText/VenetianBlindsText';

import { parseResults, getBackground } from '../../../models/Utils';
import { ADAARIARoles } from '../../../models/ADA';

const Poll = ({ cardData, isInline }) => {
  const [choice, setPollChoice] = useState(-1);
  let [animationPlaying, setAnimationPlaying] = useState(false);
  const menuOpened = useSelector(state => state.data.menuOpened);
  const activeSlideKey = useSelector(state => state.data.activeSlideKey);
  const pollServer = useSelector(state => state.config.pollServer);
  const [results, setResults] = useState();

  useEffect(() => {

    fetch(pollServer.basePath + pollServer.endPoint + cardData.Key).then(res => res.json())
    .then((data) => {
      console.log("[USER POLL] Polling data received: ",data);
      setResults(parseResults(cardData.VoteOptions, data));
    })
    .catch((error) => {
      console.log("[USER POLL] Failed to Receive Data");
      console.log(error);
      setResults(parseResults(cardData.VoteOptions, null));
    });
  }, []);

  const handleClicked = key => {
    setPollChoice(key);

    var json = {
      id: cardData.Key,
      answerId: key
    };
    fetch(pollServer.basePath + pollServer.endPoint, 
      {
        method: "POST", 
        cache: "no-cache", 
        body: JSON.stringify(json),
        headers: {
          'Content-Type': 'application/json'
        }
      });
  };

  useEffect(() => {
    if (activeSlideKey === cardData.Key) {
      setAnimationPlaying(true);
      setTimeout(() => setAnimationPlaying(false), 750);
    }
  }, [activeSlideKey, cardData]);

  var votes = [];
  if (cardData && cardData.VoteOptions) {
    for (var i = 0; i < cardData.VoteOptions.length; i++) {
      var voteOption = cardData.VoteOptions[i];
      var result = results ? results.find(e => e.key === voteOption.Key) : null;
      var key = voteOption.Key;
      votes.push(
        <PollOption
          key={key}
          dataKey={key}
          index={i}
          pollQuestion={cardData.Header}
          text={voteOption.Text}
          width={choice < 0 ? 'calc(100% + 150px)' : '100%'}
          buttonText={'Vote'}
          background={getBackground(voteOption)}
          choice={choice}
          tally={result ? result.percent + "%" : "0%"}
          onClick={handleClicked}
          tabIndex={!menuOpened ? 0 : -1}
          altText={"vote " + voteOption.Text}
        />
      );
    }
  }

  var classname = "user-poll " + (isInline ? "inline" : "");

  return (
    <div className={classname}>
      <div className="width-wrapper">
        <span className="text-holder">
    
          <div className="header target-text">
            <VenetianBlindsText show={(!animationPlaying && (cardData && cardData.Key === activeSlideKey)) || isInline} />
            <div role={ADAARIARoles.Heading} aria-level="2" >{cardData.Header}</div>
          </div>
        </span>
        <div className="vote-holder">{votes}</div>
      </div>
    </div>
  );
};

export default Poll;
